"use client"

import { Icon } from '@iconify/react';
import { Box } from '@mui/material';

import type { IconifyIcon } from '@iconify/react';
import type { BoxProps, SxProps } from '@mui/material';
import type { FC } from 'react';

export interface IconifyProps extends BoxProps {
  sx?: SxProps;
  icon: IconifyIcon;
}

export const Iconify: FC<IconifyProps> = ({ icon, sx, ...props }) => (
  <Box component={Icon} icon={icon} sx={{ ...sx }} {...props} />
);
